<template>
  <div class="wrap reserve-wrap">
    <div class="top-header">
      <incBack></incBack>
      <h3>코칭 목표 작성하기</h3>
    </div>
    <div class="body-wrap">
      <VueSlickCarousel @afterChange="onAfterChange" :swipe="false" :arrows="false" :dots="false" ref="carousel" :infinite="false">
        <div>
          <h4>
            이번 코칭에서 달성하고 싶은<br />
            목표를 작성해주세요.
          </h4>
          <!-- 코칭 목표 작성 -->
          <div class="goal-wrap pl-05 pr-05">
            <!-- 작성할 때 class="active" -->
            <textarea name="" id="" placeholder="Ex. 팀원들에게 좋은 피드백을 줄 수 있는 리더가 되기 위해 연구한다. " v-model="input.goal" @keyup="keyupEvent"></textarea>
          </div>
        </div>
        <div>
          <h4>코치님에게 바라는 점이나 기타 의견을 작성해 주세요.</h4>
          <!-- 코칭 목표 작성 -->
          <div class="goal-wrap pl-05 pr-05">
            <!-- 작성할 때 class="active" -->
            <textarea name="" id="" v-model="input.other"></textarea>
          </div>
        </div>
      </VueSlickCarousel>
    </div>
    <div class="bnb-btn">
      <!-- 선택 시 class="active" 활성화 -->
      <button @click="next()" :class="{ active: is_active }">NEXT</button>
      <!-- <p class="txt-blue">
                혹시 주제가 맘에 안든다면? <br>
                서베이를 한번 더 해볼 수 있어요!
            </p> -->
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import VueSlickCarousel from "vue-slick-carousel";
export default {
  name: "coaching_goal",
  data: () => ({
    current_slide: 0,
    is_active: false,
    input: {
      goal: "",
      other: "",
    },
  }),
  components: {
    incBack,
    VueSlickCarousel,
  },
  mounted() {},
  methods: {
    keyupEvent() {
      // console.log(event);
      // console.log(this.input.goal);
      if (this.input.goal != "") {
        this.is_active = true;
      } else {
        this.is_active = false;
      }
    },
    next() {
      if (this.is_active) {
        if (this.current_slide == 1) {
          this.$router.push("reserve_finish");
        } else {
          this.$refs.carousel.next();
        }
      }
    },
    onAfterChange(slideIndex) {
      this.current_slide = slideIndex;
      if (this.current_slide == 2) {
        this.is_active = false;
      }
    },
  },
};
</script>
